module.exports = __webpack_public_path__ + "img/logo.69c8e1a8.svg";